<template>
  <div class="vip">
     <div class="vips">
       我的VIP
     </div>
     <el-form :model="form" inline style="margin-top: 20px;">
       <el-form-item label="卡码">
         <el-input placeholder="请输入卡码" v-model="form.card_no" style="width: 200px;"></el-input>
       </el-form-item>
       <el-form-item label="卡密">
         <el-input placeholder="请输入卡密" v-model="form.card_password" style="width: 200px;"></el-input>
       </el-form-item>
       <el-form-item>
         <el-button type="success" @click="cardActive">立即激活</el-button>
         <el-button type="success" @click="$refs.goukaData.show()">购卡记录</el-button>
       </el-form-item>
     </el-form>

     <div class="vips" style="margin-top: 30px;">
       激活记录
     </div>
<el-table
          :data="list"
          style="width: 100%;margin-top:30px;" v-loading="loading">
          <el-table-column
             prop="card_no"
             label="卡码"  align="center">
           </el-table-column>
           <el-table-column
              prop="card_password"
              label="卡密"  align="center">
            </el-table-column>
            <el-table-column
               prop="create_time"
               label="激活时间"  align="center">
             </el-table-column>
          </el-table>
     <!--购卡记录-->
     <goukaVue ref="goukaData" />
     <!--购卡记录-->
  </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import goukaVue from "./son/gouka.vue"
    import { cardActive,activeRecord } from "@/api/gw/user"
  export default {
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    components:{
       goukaVue
    },
    data(){
      return{
        form:{
          card_no:"",//卡码
          card_password:"",//卡密
        },
        list:[],
        loading:false,
      }
    },
    props:{

    },
    watch:{

    },
    mounted(){
      this.activeRecord();//激活记录
    },
    methods:{
      //激活记录
      activeRecord(){
        this.loading = true
        activeRecord({}).then(res=>{
          console.log("激活记录",res.data);
          this.list = res.data
        }).finally(()=>{
          this.loading= false
        })
      },
      //激活卡密
      cardActive(){
        if(!this.form.card_no || !this.form.card_password){
          this.$message.error("卡码和卡密不能为空");
          this.form.card_no = ""
          this.form.card_password = ""
          return;
        }
        const loading = this.$loading({
           lock: true,
           text: '激活中',
           spinner: 'el-icon-loading',
           background: 'rgba(0, 0, 0, 0.7)'
         });
        cardActive({
          card_no:this.form.card_no,
          card_password:this.form.card_password
        }).then(()=>{
          this.$message.success("激活成功");
          this.$store.dispatch("getUserInfo");
          this.form.card_no = ""
          this.form.card_password = ""
          //此时再请求激活记录
          this.activeRecord();
        }).finally(()=>{
          loading.close();
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.vips{
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/vip.vue